import React, { useEffect, useState } from 'react';
import { api, msg } from './hubApi';

const money = n => 'A$' + Number(n || 0).toFixed(2);
const dt = iso => iso ? new Date(iso).toLocaleString('en-AU', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', timeZone: 'Australia/Sydney' }) : '–';

export default function Admin() {
  const [s, setS] = useState(null);
  const [note, setNote] = useState('');
  const load = () => api('/admin/billing').then(setS).catch(e => setNote(msg(e)));
  useEffect(() => { load(); }, []);
  const run = async () => {
    if (!window.confirm('Send all payouts that are due now?')) return;
    try { const r = await api('/admin/payouts/run', { method: 'POST' }); setNote(`Payout run: ${r.filter(x => x.sent).length} sent, ${r.filter(x => x.skipped).length} skipped, ${r.filter(x => x.failed).length} failed.`); load(); }
    catch (e) { setNote(msg(e)); }
  };
  if (!s) return <p>{note || 'Loading…'}</p>;
  return (
    <>
      <section className="card">
        <div className="row between"><h2>Marketplace money</h2><span className="pill">PayPal {s.paypalEnv || 'not connected'}{s.webhook ? ' · webhook on' : ' · webhook off'}</span></div>
        <div className="stats">
          <div><b>{money(s.gross)}</b><span>total sales</span></div>
          <div><b>{money(s.platformFee)}</b><span>Betbuilder 20%</span></div>
          <div><b>{money(s.leaderHeld)}</b><span>leaders, on hold</span></div>
          <div><b>{money(s.leaderAvailable)}</b><span>leaders, due now</span></div>
          <div><b>{money(s.leaderPaid)}</b><span>leaders, paid</span></div>
        </div>
        <div className="row"><button className="sm" onClick={run}>Run payouts now</button><span className="note">{note || 'Payouts also run automatically on Mondays from 10am.'}</span></div>
      </section>
      {!!s.refundFlags.length && <section className="card warn"><h2>Refunds / reversals to check ({s.refundFlags.length})</h2>
        <p className="fine">PayPal reported these. Check the payment in PayPal and adjust the leader’s payout if needed.</p>
        <ul>{s.refundFlags.map(f => <li key={f._id}>{f.type} · {f.resourceId} · {dt(f.at)}</li>)}</ul></section>}
      <section className="card"><h2>Recent payments</h2><div className="scroll"><table>
        <thead><tr><th>Paid</th><th>Kind</th><th className="r">Gross</th><th className="r">Fee</th><th className="r">Leader</th><th>Status</th><th>PayPal ref</th></tr></thead>
        <tbody>{s.payments.map(p => <tr key={p._id}><td>{dt(p.paidAt)}</td><td>{p.kind}{p.recurring ? ' ↻' : ''}</td><td className="r">{money(p.gross)}</td><td className="r">{money(p.platformFee)}</td><td className="r">{money(p.leaderShare)}</td><td>{p.status}</td><td className="raw">{p.paypalId}</td></tr>)}</tbody>
      </table></div></section>
      <section className="card"><h2>Payouts</h2><div className="scroll"><table>
        <thead><tr><th>Created</th><th>To</th><th className="r">Amount</th><th>Status</th><th>Batch</th></tr></thead>
        <tbody>{s.payouts.map(p => <tr key={p._id}><td>{dt(p.createdAt)}</td><td>{p.email}</td><td className="r">{money(p.amount)}</td><td>{p.status}{p.error ? ' · ' + p.error.slice(0, 80) : ''}</td><td className="raw">{p.batchId || ''}</td></tr>)}</tbody>
      </table></div></section>
    </>
  );
}
